import posthog from '@leyan/lytics';

/** 消息展示失败上报 */
export default function chatMsgRenderFailReport(msgType: string, msg?: any) {
  posthog.capture('$chatMsgRenderFail', {
    msgType,
    msg,
  });
}
